import {
  Button,
  IconButton,
  TextField,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import "../User-Master/user-management.css";
import EditIcon from "@mui/icons-material/Edit";
import { DataGrid } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import DownloadIcon from "@mui/icons-material/Download";
import React, { useState, useEffect, useCallback } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { useSelector } from "react-redux";
import {
  getUserData,
  addUserData,
  deleteUserData,
  updateUserData,
  getRoleList
} from "../../../redux/API/api_UserManagement";
import UserDalog from "./user-dialog";
import SnackbarCustom from "../../../components/Snackbar/Snackbar";

export default function UserManagement() {
  const columns = [
    { field: "gid", headerName: "GID", width: 200 },
    { field: "roleName", headerName: "Role", width: 200 },
    { field: "userFirstName", headerName: "First Name", width: 200 },
    { field: "userLastName", headerName: "Last Name", width: 200 },
    { field: "userEmail", headerName: "E-mail", width: 450 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      sortable: false,
      width: "20px",
      gap: "20px",

      renderCell: (params) => (
        <div>
          <IconButton
            color="primary"
            onClick={() => handleEditUser(params.row)}
          >
            <EditIcon style={{ cursor: "pointer" }} />
          </IconButton>
          <IconButton onClick={() => handleDelete(params.row)}>
            <DeleteIcon />
          </IconButton>
        </div>
      ),
    },
  ];

  const [rows, setRows] = useState();
  const [initialRows, setInitialRows] = useState([]);
  const [editUser, setEditUser] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [open, setOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [openForDelete, setOpenForDelete] = useState(false);
  const [deleteUser, setDeleteUser] = useState([]);

  const UID = useSelector((state) => state.saveUserIdReducer);
  const userdetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const siteToken = useSelector((state) => state.saveTokenReducer);
  const azureToken = useSelector((state) => state.saveAzureTokenReducer);


  useEffect(() => {
    getTableData();
    
  }, []);

  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpen(true);
  };

  // fileting data based on the input global search
  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchText(value);
    const filteredRows = initialRows.filter((row) =>
      Object.values(row).some((field) =>
        field ? field.toString().toLowerCase().includes(value) : ""
      )
    );
    setRows(filteredRows);
  };

  // table data search clear
  const clearSearch = () => {
    setSearchText("");
    setRows(initialRows);
  };

  // snackbar close
  const handleClose = (e) => {
    setOpen(false);
  };

  // getting user list
  function getTableData() {
    setIsLoader(true);
    getUserData(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId
    )
      .then((response) => {
        setInitialRows(response);
        setRows(response);
        console.log("rows", rows);
        setIsLoader(false);
      })
      .catch((error) => {
        console.log("Error: " + error, "error");
        setIsLoader(false);
      });
  }

 

  const handleEditUser = (users) => {
    setEditUser(users);
    setOpenDialog(true);
  };

  const handleUpdateUser = (newuser) => {
    setOpenDialog(false);
    handleRowUpdate(newuser);
  };

  // opening user dialog when  user clicks on add button
  const handleAdduser = useCallback(() => {
    setEditUser(null);
    setOpenDialog(true);
  }, []);

  // closing dialog and calling save api function
  const handleSaveUser = (newUser) => {
    setOpenDialog(false);
    handleRowAdd(newUser);
  };

  // when user click on delete icon opening dilog box and setting user
  const handleDelete = (user) => {
    setOpenForDelete(true);
    setDeleteUser(user);
  };

  // inserting user
  const handleRowAdd = (newTableData) => {
    setIsLoader(true);
    newTableData.LoggedInUserId = userdetails.userId;
    delete newTableData.UserId;
    addUserData(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      newTableData
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          setIsLoader(false);
          getTableData();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setIsLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };

  // updating selected user
  const handleRowUpdate = (newTableData) => {
    setIsLoader(true);
    newTableData.loggedinUserId = userdetails.userId;
    updateUserData(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      newTableData
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          setIsLoader(false);
          getTableData();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setIsLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };

  // deleting selectd user
  const handleRowDelete = () => {
    setIsLoader(true);
    setOpenForDelete(false);
    let user = {};
    user.UserFirstName = deleteUser.userFirstName;
    user.UserLastName = deleteUser.userLastName;
    user.UserEmail = deleteUser.userEmail;
    user.RoleName = deleteUser.roleName;
    user.Gid = deleteUser.gid;
    user.RoleId = deleteUser.roleId;
    user.PassWord = "";
    user.GeneratedOTP = "";
    user.SupplierName = "";
    user.LoggedInUserName = "";
    user.UserId = deleteUser.userId;

    user.LoggedInUserId = userdetails.userId;

    deleteUserData(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      user
    )
      .then((response) => {
        if (response.response) {
          handleSnackOpen(response.responseMsg, "success");
          setIsLoader(false);
          getTableData();
        } else {
          handleSnackOpen(response.responseMsg, "error");
          setIsLoader(false);
        }
      })
      .catch((error) => {
        handleSnackOpen("Exception : " + error, "error");
        setIsLoader(false);
      });
  };

  // closing delete dialog box
  const handleCloseforDelete = () => {
    setOpenForDelete(false);
    setDeleteUser([]);
  };

  // downloding data in excel
  const exportToExcel = () => {
    let ExcelData = [];
    for (let i = 0; i < rows?.length; i++) {
      let input = {};
      input.SrNo = i + 1;
      input.FirstName = rows[i]?.userFirstName;
      input.LastName = rows[i]?.userLastName;
      input.Email = rows[i]?.userEmail;
      input.Gid = rows[i]?.gid;
      input.Role = rows[i]?.roleName;
      ExcelData.push(input);
    }
    const worksheet = XLSX.utils.json_to_sheet(ExcelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "User Master");
    XLSX.writeFile(workbook, "UserList.xlsx");
  };

  return (
    <Box sx={{ padding: "10px", border: "1px solid #ccc" }}>
      <Typography variant="h5" gutterBottom>
        User Master
      </Typography>
      {/* <div>
        <TextField
          label="First Name"
          variant="standard"
          size="small"
          style={{ marginRight: "16px", fontWeight: "500", fontSize: "13px" }}
        />
        <TextField
          label="Last Name"
          variant="standard"
          size="small"
          style={{ marginRight: "16px", fontWeight: "500", fontSize: "13px" }}
        />
        <TextField
          label="Email Id"
          variant="standard"
          size="small"
          style={{ marginRight: "16px", fontWeight: "500", fontSize: "13px" }}
        />
        <TextField
          label="Gid"
          variant="standard"
          size="small"
          style={{ marginRight: "16px", fontWeight: "500", fontSize: "13px" }}
        />
        <Button
          variant="contained"
        
          style={{ marginRight: "8px" , fontFamily: "SiemensSans-Bold, sans-serif",
            backgroundColor:"#008aa6"}}
            startIcon={<SearchIcon/>}
           
        >
          Search
        </Button>
        <Button variant="outlined"   startIcon={<ReplayIcon/>}  style={{  fontFamily: "SiemensSans-Bold, sans-serif",
              backgroundColor:"#008aa6", color:'white'}}>
          Reset
        </Button>
      </div> */}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "10px",
        }}
      >
        <SearchIcon color="action" />
        <TextField
          variant="standard"
          placeholder="Search"
          value={searchText}
          onChange={handleSearch}
          sx={{ marginLeft: "5px", width: "400px" }}
        ></TextField>
        <IconButton onClick={clearSearch} size="small">
          <ClearIcon fontSize="small" />
        </IconButton>

        <Box
          sx={{
            display: "flex",
            flexWrap:"nowrap",
            overflow:"hidden",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "20px",
            width: "100%",
          }}
        >
          <Tooltip title="Download excel">
            <IconButton size="small" onClick={exportToExcel}>
              <DownloadIcon />
            </IconButton>
          </Tooltip>
          <Button className="btn"
            variant="contained"
            onClick={handleAdduser}
           // startIcon={<AddIcon />}
          >
            Add User
          </Button>

          <UserDalog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            onSave={handleSaveUser}
            onUpdate={handleUpdateUser}
            userToEdit={{ editUser }}
          
          />
        </Box>
      </Box>
      <div style={{ height: 530, width: "100%" }}>
        <DataGrid
          
          rows={rows}
          columns={columns}
          pageSize={4}
          getRowId={(row) => row.userId}
          rowsPerPageOptions={[4]}
          loading={isLoader}
          disableRowSelectionOnClick
          localeText={{
            noRowsLabel: "No Matching Records Found!",
          }}
          //getRowHeight={()=>"auto"}
          sx={{
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#d3d3d3",
              fontWeight: "500",
              fontSize: "13px",
              color: "black",
              lineHeight: "1.5rem",
            },
            "& .MuiDataGrid-columnHeader": { backgroundColor: "#d3d3d3" },

            "& .MuiDataGrid-cell": { textAlign: "left", fontSize: "12px",display:"flex",alignItems:"center"},

            "& .MuiDataGrid-footerContainer": {
             // border: "1px solid #000",
              fontSize: "12px",
              //overflow:"hidden !important",
              //minHeight:"auto",
              //maxHeight:"none",
            },
          }}
        />

        <>
          <SnackbarCustom
            open={open}
            message={snackMessage}
            alertType={alertType}
            handleClose={handleClose}
          />
        </>

        <Dialog
          open={openForDelete}
          onClose={handleCloseforDelete}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete the user?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseforDelete}
              className="pt-button--secondary"
            >
              Cancel
            </Button>
            <Button
              onClick={() => handleRowDelete()}
              className="pt-button--primary"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </Box>
  );
}
